import { createFileRoute } from "@tanstack/react-router"
import { useAuth0 } from "@auth0/auth0-react"
import AuthError from "~/components/reusable/errors/AuthError"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import { applyMockAuthLogin } from "~/utils/mockAuth"

export const Route = createFileRoute("/login/$orgName")({
  beforeLoad: async ({ params }) => {
    const search = new URLSearchParams(window.location.search)
    const mock = search.has("mock")
    if (!applyMockAuthLogin(params.orgName, mock, search.get("user"))) return
    window.location.replace(mock ? "/" : window.location.pathname)
    // The reload swaps the auth provider; rendering this page would start an Auth0 redirect first.
    await new Promise(() => {})
  },
  component: RouteComponent,
  errorComponent: AuthError,
})

function RouteComponent() {
  const { loginWithRedirect, error, isLoading } = useAuth0()
  const { orgName } = Route.useParams()

  if (isLoading) return <LoadingOverlay size="lg" height="h-[100vh]" messages="Authenticating..." />

  if (error) {
    return <AuthError />
  }

  loginWithRedirect({
    appState: { returnTo: "/" },
    authorizationParams: { organization: orgName },
  })

  return <LoadingOverlay size="lg" height="h-[100vh]" messages={`Logging in to ${orgName}...`} />
}
